import styled, { keyframes, css } from 'styled-components'
import { rem } from 'utils/common'
import { device } from 'components/Variable'

const blum = keyframes`
  0% {
    opacity: 1;
  }
  50% {
    opacity: .1;
  }
  100% {
    opacity: 1;
  }
`
const defaultStyle = css`
	background-color: ${({ theme }) => theme.color.grayOne};
	border-radius: ${rem(4)};
	width: 100%;
`

export const Orders = styled.div`
	position: relative;

	& > div:nth-child(2n) {
		animation-delay: 0.2s;
	}

	& > div:nth-child(3n) {
		animation-delay: 0.4s;
	}

	& > div:nth-child(4n) {
		animation-delay: 0.6s;
	}

	& > div:nth-child(5n) {
		animation-delay: 0.8s;
	}

	& > div:nth-child(6n) {
		animation-delay: 1s;
	}

	& > div:nth-child(7n) {
		animation-delay: 1.2s;
	}

	& > div:nth-child(8n) {
		animation-delay: 1.4s;
	}

	& > div:nth-child(9n) {
		animation-delay: 1.6s;
	}

	& > div:nth-child(10n) {
		animation-delay: 1.8s;
	}

	& > div:nth-child(11n) {
		animation-delay: 2s;
	}
`
export const Order = styled.div`
	margin-bottom: ${rem(20)};
	border-radius: ${rem(8)};
	display: flex;
	align-items: center;
	justify-content: space-between;
	padding: ${rem(15, 22)};
	background-color: ${({ theme }) => theme.color.secondary};
	animation: 1.3s infinite ${blum};
	& > div {
		flex: 1 0;
	}
`

export const OrderId = styled.div`
	${defaultStyle};
	height: ${rem(25)};
	margin-bottom: ${rem(6)};
	max-width: ${rem(200)};
	@media (${device.tablet}) {
		height: ${rem(18)};
	}
`
export const OrderDate = styled.div`
	${defaultStyle};
	height: ${rem(19)};
	max-width: ${rem(90)};
	@media (${device.tablet}) {
		height: ${rem(16)};
	}
`
export const Arrow = styled.div`
	${defaultStyle};
	width: ${rem(40)};
	height: ${rem(40)};
	border-radius: 50%;
	@media (${device.tablet}) {
		width: ${rem(26)};
		height: ${rem(26)};
	}
`
export const OrderPrice = styled.div`
	${defaultStyle};
	max-width: ${rem(50)};
	height: ${rem(19)};
	margin-bottom: ${rem(10)};
`
export const OrderQuantity = styled.div`
	${defaultStyle};
	max-width: ${rem(80)};
	height: ${rem(16)};
`
